import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

interface IProps {
    open: boolean;
    handleClose: () => void;
    handleSure: () => void;
    title: string;
    description: string;
    sureWord: string;
    closeWord: string;
    note?: string;
}

export default function GlobalPopUp(props: IProps) {
    return (
        <>
            <Dialog
                open={props.open}
                onClose={props.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {props.description}
                    </DialogContentText>
                    <DialogContentText
                        id="alert-dialog-description"
                        sx={{ fontSize: "12px", mt: 1 }}
                    >
                        Note: {props.note ?? ""}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{ width: 120 }}
                        variant="outlined"
                        onClick={props.handleClose}
                    >
                        {props.closeWord}
                    </Button>
                    <Button
                        sx={{ width: 120 }}
                        onClick={props.handleSure}
                        autoFocus
                    >
                        {props.sureWord}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
